"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectContactDataTool = void 0;
const zod_1 = require("zod");
exports.detectContactDataTool = {
    name: 'detectContactData',
    description: `MANDATORY: Always check if the user's message contains contact information and call this tool if any is found.    

    This tool detects and processes contact data from user messages including ANY type of following data:
    - Phone numbers (mobile, landline, international formats)
    - Email addresses
    - Physical addresses (street, city, postal code, country)
    - Names (first name, last name, full names)
    - Company names and job titles
    - Social media handles
    - Website URLs

    Excecute this tool every time user message contains any of mentioned contact data types.
    
    WHEN TO CALL THIS TOOL:
    - When user mentions phone numbers in any format
    - When user provides email addresses
    - When user shares physical addresses or locations
    - When user mentions names of people or companies
    - When user provides contact information in any form
    
    Extract all contact data found in the user's message and categorize it appropriately.
    This tool handles its own response continuation - you will continue responding normally after it executes.

    If this tool data tag: <tool-data toolName="detectContactData">
      <tool-data-entry key="isFormOpen">true</tool-data-entry>
    </tool-data> hask its value as true also detect this tool.
    
    `,
    zodSchema: zod_1.z.object({
        contactData: zod_1.z.object({
            phoneNumbers: zod_1.z.array(zod_1.z.string()).describe('Array of detected phone numbers in any format').optional(),
            emails: zod_1.z.array(zod_1.z.string()).describe('Array of detected email addresses').optional(),
            addresses: zod_1.z.array(zod_1.z.string()).describe('Array of detected physical addresses').optional(),
            names: zod_1.z.array(zod_1.z.string()).describe('Array of detected person names').optional(),
            companies: zod_1.z.array(zod_1.z.string()).describe('Array of detected company names').optional(),
            socialMedia: zod_1.z.array(zod_1.z.string()).describe('Array of detected social media handles or URLs').optional(),
            websites: zod_1.z.array(zod_1.z.string()).describe('Array of detected website URLs').optional(),
            other: zod_1.z.array(zod_1.z.string()).describe('Array of other contact information not fitting above categories').optional()
        }).describe('Object containing categorized contact data detected from the user message')
    }),
    blockStream: false
};
